import { MicrobiologyDataModule } from './../on-screen-results/microbiology-data/microbiology.module';
import { UserPermissionsModule } from './../user-permissions/user-permissions.module';
import { SiteDocumentsComponent } from './documents/site-documents.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CovanceDatePickerModule } from '../covance-date-picker/covance-date-picker.module';
import { CovanceAgGridModule } from '../covance-ag-grid/covance-ag-grid.module';
import { SharedModule } from '../shared';
import { UserModule } from '../user';
import { AuditTrailModule } from './../audit-trail/audit-trail.module';
import { GlobalPopupModule } from '../global-popup';
import { SponsorGuard } from './sponsor-guard';
import { SponsorNavigationComponent } from './navigation/sponsor-navigation.component';
import { NavigationModule } from '../navigation';
import { SelectedStudyResolver } from '../sponsor/selected-study-resolver';
import { SponsorReportsStorage } from './sponsor-reports-storage';
import { SponsorCommunicationsComponent } from './documents/sponsor-communications.component';
import { DocumentsModule } from '../documents/documents.module';
import { StudyDocumentsComponent } from './documents/study-documents.component';
import { DocumentsByChildComponent } from './documents/documents-by-child.component';
import { StudySubjectsComponent } from './subjects/study-subjects.component';
import { SponsorUnreadReportsStorage } from './sponsor-unread-reports-storage';
import { SponsorLevelComponent } from './sponsor-level.component';
import { SponsorProtocolAccessReportComponent } from './activity-reports/sponsor-protocol-access-reports.component';
import { SponsorActivityReportDocumentsComponent } from './activity-reports/sponsor-activity-report-documents.component';
import { SponsorActivityReportsComponent } from './activity-reports/sponsor-activity-reports.component';
import { SponsorProtocolAccessessStorage } from './activity-reports/sponsor-protocol-accesses-storage';
import { SponsorResultAlertsComponent } from './result-alerts/sponsor-result-alerts.component';
import { SponsorActivityReportsDocumentsColumns } from './activity-reports/sponsor-activity-reports-documents-columns';
import { SponsorActivityReportsFilterResolver } from './activity-reports/sponsor-activity-reports-filter-resolver';
import { SponsorSubjectComponent } from './subjects/sponsor-subject.component';
import { SponsorSubjectsStorage } from './sponsor-subjects-storage';
import { SponsorTrendAnalysisComponent } from './lab-results/sponsor-trend-analysis.component';
import { SponsorTrendsComponent } from './lab-results/sponsor-trends.component';
import { LabResultsFilterStorage } from './lab-results/lab-results-filter-storage';
import { CategoryDocumentsFilterStorage } from './documents/category-documents-filter-storage';
import { SponsorLabResultsStorage } from './lab-results/sponsor-lab-results-storage';
import { SponsorStudySitesStorage } from './sites/sponsor-study-sites-storage';
import { StudySitesComponent } from './sites/study-sites.component';
import { CorporateModule } from '../corporate/corporate.module';
import { SponsorSubjectLabTestsGridComponent } from './subjects/sponsor-subject-lab-tests-grid.component';
import { CanSponsorViewDocumentCategoryGuard } from './can-sponsor-view-document-category-guard';
import { SponsorCtSubjectsStorage } from './subjects/sponsor-ct-subjects-storage';
import { CanSponsorViewActivityReportsGuard } from './can-sponsor-view-activity-reports-guard';
import { SponsorStudyPermissionsResolver } from './sponsor-study-permissions-resolver';
import { CanSponsorViewProtocolAccessGuard } from './can-sponsor-view-protocol-access-guard';
import { CanSponsorViewStudyDocumentsGuard } from './can-sponsor-view-study-documents-guard';
import { CanSponsorViewKitInventoryGuard } from './can-sponsor-view-kit-inventory-guard';
import { CanSponsorViewStudyHealthDashboardGuard } from './can-sponsor-view-study-health-dashboard';
import { CanSponsorViewEQueriesGuard } from './can-sponsor-view-e-queries-guard';
import { SponsorKitInventoryFiltersGuard } from './kit-inventory/sponsor-kit-inventory-filters-guard';
import { SponsorTestResultsComponent } from './lab-results/sponsor-test-results.component';
import { SponsorStandardTestResultsComponent } from './lab-results/sponsor-standard-test-results.component';
import { StandardTestResultsMainModule } from '../on-screen-results';
import { SponsorMicrobiologyComponent } from './lab-results/sponsor-microbiology.component';
import { SiteDocumentsGridComponent } from './documents/site-documents-grid.component';
import { SponsorStudySiteIdentitiesResolver } from './lab-results/sponsor-study-site-identities-resolver';
import { SponsorSelectedStudySiteIdentityResolver } from './lab-results/sponsor-selected-study-site-identity-resolver';
import { SiteDocumentsRedirectionComponent } from './documents/site-documents-redirection.component';
import { SponsorTrendAnalysisRedirectionComponent } from './lab-results/sponsor-trend-analysis-redirection.component';
import { SponsorTestResultsRedirectionComponent } from './lab-results/sponsor-test-results-redirection.component';
import { SubjectsModule } from '../subjects/subjects.module';
import { SponsorBoxplotComponent } from './lab-results/sponsor-boxplot.component';
import { SponsorSubjectIdentitiesResolver } from './subjects/sponsor-subject-identities-resolver';
import { SponsorStudySiteIdentitiesStorage } from './sites/sponsor-study-site-identities-storage';
import { SponsorActivityReportsFiltersGuard } from './activity-reports/sponsor-activity-reports-filters-guard';
import { SponsorLabReportsComponent } from './documents/lab-reports/sponsor-lab-reports.component';
import { SponsorKitInventoryComponent } from './kit-inventory/sponsor-kit-inventory.component';
import { TableauComponent } from './tableau/tableau.component';
import { TableauDialogComponent } from './tableau/tableau-dialog.component';
import { SponsorKitInventoryOnHandComponent } from './kit-inventory/sponsor-kit-inventory-onhand.component';
import { SponsorKitInventoryExpirationComponent } from './kit-inventory/sponsor-kit-inventory-expiration.component';
import { KitInventoryColumns } from '../investigator/kitinventory/kit-inventory-columns';
import { SponsorEQueryModule } from './e-queries/sponsor-equery.module';
import { TableauStorage } from './tableau/tableau-storage';
import { SponsorEReqModule } from './activity-reports/eReq-reports/sponsor-ereq-module';

@NgModule({
    declarations: [
        SponsorCommunicationsComponent,
        StudyDocumentsComponent,
        SiteDocumentsComponent,
        SiteDocumentsRedirectionComponent,
        DocumentsByChildComponent,
        SiteDocumentsGridComponent,
        StudySubjectsComponent,
        SponsorNavigationComponent,
        SponsorLevelComponent,
        SponsorActivityReportsComponent,
        SponsorActivityReportDocumentsComponent,
        SponsorProtocolAccessReportComponent,
        SponsorResultAlertsComponent,
        SponsorSubjectComponent,
        SponsorTrendAnalysisComponent,
        SponsorTrendsComponent,
        SponsorBoxplotComponent,
        SponsorTrendAnalysisRedirectionComponent,
        StudySitesComponent,
        SponsorSubjectLabTestsGridComponent,
        SponsorTestResultsComponent,
        SponsorTestResultsRedirectionComponent,
        SponsorStandardTestResultsComponent,
        SponsorMicrobiologyComponent,
        SponsorLabReportsComponent,
        SponsorKitInventoryComponent,
        SponsorKitInventoryOnHandComponent,
        SponsorKitInventoryExpirationComponent,
        TableauComponent,
        TableauDialogComponent,
    ],
    imports: [
        SharedModule,
        DocumentsModule,
        UserPermissionsModule,
        GlobalPopupModule,
        ReactiveFormsModule,
        CovanceAgGridModule,
        CovanceDatePickerModule,
        UserModule,
        AuditTrailModule,
        NavigationModule,
        CorporateModule,
        StandardTestResultsMainModule,
        MicrobiologyDataModule,
        SubjectsModule,
        SponsorEQueryModule,
        SponsorEReqModule
    ],
    providers: [
        SponsorGuard,
        CanSponsorViewDocumentCategoryGuard,
        CanSponsorViewStudyDocumentsGuard,
        LabResultsFilterStorage,
        SponsorReportsStorage,
        SelectedStudyResolver,
        SponsorStudySiteIdentitiesResolver,
        SponsorSelectedStudySiteIdentityResolver,
        SponsorUnreadReportsStorage,
        SponsorProtocolAccessessStorage,
        SponsorActivityReportsDocumentsColumns,
        KitInventoryColumns,
        SponsorActivityReportsFilterResolver,
        SponsorSubjectsStorage,
        CategoryDocumentsFilterStorage,
        SponsorStudySitesStorage,
        SponsorLabResultsStorage,
        SponsorSubjectIdentitiesResolver,
        SponsorCtSubjectsStorage,
        CanSponsorViewActivityReportsGuard,
        SponsorStudyPermissionsResolver,
        CanSponsorViewProtocolAccessGuard,
        CanSponsorViewKitInventoryGuard,
        CanSponsorViewStudyHealthDashboardGuard,
        CanSponsorViewEQueriesGuard,
        SponsorKitInventoryFiltersGuard,
        SponsorStudySiteIdentitiesStorage,
        SponsorActivityReportsFiltersGuard,
        TableauStorage,
    ],
    entryComponents: [
        SponsorNavigationComponent,
        TableauDialogComponent
    ]
})
export class SponsorModule { }
